var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{staticClass:"dine-add-card",attrs:{"id":"store-map-popup","size":"lg","centered":"","hide-header":true,"hide-footer":true}},[_c('div',{staticClass:"map-modal"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.$bvModal.hide('store-map-popup')}}},[_c('span',[_vm._v("×")])]),(_vm.currentStore)?_c('iframe',{attrs:{"height":"250","frameborder":"0","scrolling":"no","marginheight":"0","marginwidth":"0","src":`https://maps.google.com/maps?q=${
          _vm.currentStore.location_coordinates.lat
        },${
          _vm.currentStore.location_coordinates.lng
        }&hl=an&z=14&output=embed`}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }